<template>
    <div>
        <iframe :src="iframesrc" class="iframe"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframesrc: '',
            exhibition_id: '',
        };
    },
    mounted() {
        this.isShow = false;
        this.$root.$on("close", (idName, router) => {
            this.flagNum = 0;
        });
        // this.$refs.video.currentTime = 5;
        // this.$refs.video.addEventListener("ended", () => {
        //     this.isShow = true;
        // });
        this.exhibition_id = this.$route.query.exhibition_id
        console.log(this.exhibition_id)
        if(this.exhibition_id){
            switch (this.exhibition_id) {
                case '21':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=d278b8a425c35a3f";
                    break;
                case '25':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=c9ee9b4475756fcb";
                    break;
                case '31':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=a5e2548adba633b9";
                    break;
                case '41':
                    this.iframesrc = "https://pano.cloudvhall.com/#/preview?view_uuid=bb07a1e89c9653fe";
                    break;
                default:
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.iframe{
    width: 100%;
    border: 0px;
    height: 14.5rem;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileBigconference/index.vue